import { jsx as t } from "react/jsx-runtime";
import { DotProgress as o } from "../../DotProgress/index.js";
import '../../../assets/index48.css';const r = "_emptyState_uc0wp_1", a = {
  emptyState: r
};
function p({ isLoading: e }) {
  return /* @__PURE__ */ t("div", { className: a.emptyState, children: e ? /* @__PURE__ */ t(o, { "aria-label": "Loading..." }) : "No results" });
}
export {
  p as SelectEmptyState
};
